<script setup lang="ts">
import { Icon } from '@iconify/vue'

const props = defineProps<{ backButtonText: string; title?: string; subtitle?: string; fixedHeader?: boolean }>()
const emit = defineEmits(['onBackClick'])
</script>

<template>
  <div class="w-full max-h-screen flex flex-col min-w-[992px]" :class="fixedHeader ? 'gap-0' : 'gap-6'">
    <header class="flex flex-col gap-3 px-8 pt-6 bg-inherit">
      <el-button class="self-start" link @click="emit('onBackClick')">
        <span class="inline-flex gap-4 items-center">
          <Icon icon="material-symbols:west-rounded" inline :height="20" />
          {{ backButtonText }}
        </span>
      </el-button>
      <div class="w-full inline-flex justify-between items-center">
        <div class="flex flex-col gap-4">
          <h2 v-if="props.title">{{ props.title }}</h2>
          <h4 v-if="props.subtitle">{{ props.subtitle }}</h4>
        </div>
        <div className="flex self-start items-start">
          <slot name="controls" />
        </div>
      </div>
      <slot name="navigation" />
    </header>
    <main class="flex-1 flex flex-col gap-6 px-8 pb-6" :class="fixedHeader && 'overflow-y-auto'">
      <slot />
    </main>
  </div>
</template>
